import { get } from 'svelte/store';
import { sessionStore } from '../stores';
import { request } from './request';
import { API_BASE_URL } from './config';

export function feedImageUrl(item) {
  const path = typeof item === 'string' ? item : item.image || '';
  if (/^https?:\/\//.test(path)) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/static/feed_images/${path}`}`;
}
export function getFeed(filters = {}, signal) {
  const params = new URLSearchParams(Object.entries(filters).filter(([, value]) => value !== '' && value != null));
  return request(`/api/feed_images?${params}`, { authenticated: get(sessionStore).loggedIn, signal });
}
export function feedAction(item, action, method = 'POST', body) {
  return request(`/api/feed_images/${encodeURIComponent(item.id)}${action ? `/${action}` : ''}`, { method, body });
}
export function publishImage(payload) { return request('/api/feed_images', { method: 'POST', body: payload }); }
export function canPublish(feature, options = {}) {
  return Boolean(feature && !['remove_background', 'remove_background_from_url', 'image_composite', 'make_video'].includes(feature)
    && (options.style_backend || options.selectedStyleBackend) !== 'easter'
    && !['모에화', '페페', '유사 탑건', '할로윈'].includes(options.style || options.selectedStyle));
}
export function shareUrl(item) { return `${API_BASE_URL}/community/images/${encodeURIComponent(item.id)}`; }
